import { useTranslation } from '@exam-room/translations';

import { CopyToClipboard } from '../../../../components';
import { QuestionTypeChip, type QuestionTypeChipProps } from '../question-type-chip';

import { questionPropertyMapper } from './constants';

interface QuestionHeaderProps {
  calculation: string;
  difficulty: string;
  refCode: string;
  questionType: QuestionTypeChipProps;
  variant: 'summary' | 'details';
}

export default function QuestionHeader(props: Readonly<QuestionHeaderProps>) {
  const { calculation, difficulty, refCode, questionType } = props;

  const isDetails = props.variant === 'details';
  const { t } = useTranslation();
  const calculationText = questionPropertyMapper[calculation as keyof typeof questionPropertyMapper]
    ? t(questionPropertyMapper[calculation as keyof typeof questionPropertyMapper])
    : calculation;
  const difficultyText = questionPropertyMapper[difficulty as keyof typeof questionPropertyMapper]
    ? t(questionPropertyMapper[difficulty as keyof typeof questionPropertyMapper])
    : difficulty;

  return (
    <div className='flex w-full items-center justify-between overflow-auto rounded-2xl bg-white px-6 py-4 shadow-sm'>
      <h5>{t('examPreview.questionHeader.question')}</h5>
      <div className='flex gap-4'>
        {isDetails ? (
          <>
            <div className='flex items-center gap-2'>
              <p className='text-text-secondary'>{t('examPreview.questionHeader.difficulty')}:</p>
              <p>{[difficultyText, calculationText].filter(Boolean).join(', ')}</p>
            </div>
            <div className='border-border-divider h-full border-l' />
            <div className='flex items-center gap-2'>
              <p className='text-text-secondary'>{t('examPreview.questionHeader.qType')}:</p>
              <QuestionTypeChip {...questionType} />
            </div>
            <div className='border-border-divider border-l' />
          </>
        ) : null}
        <div>
          <CopyToClipboard text={refCode}>
            <div className='text-text-primary w-fit rounded-[28px] bg-gray-100 px-4 py-1.5 text-sm font-semibold'>
              {refCode}
            </div>
          </CopyToClipboard>
        </div>
      </div>
    </div>
  );
}
